<template>
  <div>
    <div class="action-bar">
      <el-button type="primary" size="small" @click="reasonAction('add')" v-if="isShow">新增原因</el-button>
    </div>
    <el-table :data="reasonTableData" style="width: 100%" border ref="multipleTable" v-loading="reasonLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" :row-key="getRowKeys" @selection-change="handleSelectionChange" @row-click="rowClick">
       <el-table-column prop="" label="操作" align="center" v-if="isShow" width="250">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="reasonAction('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeAction(scope.row.number)"></el-button>
        </template>
      </el-table-column>
      <el-table-column type="selection" width="50" align="center" v-if="!isShow"> </el-table-column>
      <el-table-column prop="number" label="序号" align="center" width=100></el-table-column>
      <el-table-column prop="content" label="驳回原因" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.content}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
            :page-sizes="[5, 10, 15, 20]"
            :current-page="params.pageNumber"
            :page-size="params.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="reasonTotal"
            background
            v-if="reasonTotal > 10"
            @size-change="changeSize"
            @current-change="changeCurrent"
            highlight-current-row="true"
        ></el-pagination>
    <div>
           <el-dialog :title="titleInside" :visible.sync="dialogVisibleInside" width="800px" :before-close="handleCloseInside" :close-on-click-modal="false" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="90px">
              <el-form-item label="驳回原因:" prop="statusDesc">
                <el-input type="textarea" :rows="3" placeholder="请输入驳回原因" v-model="form.content">
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="handleCloseInside" size="small">取 消</el-button>
              <el-button type="primary" @click="submitDate()" :loading="flag" size="small">确 认</el-button>
            </div>
            </el-dialog>
        </div>
  </div>
</template>
<script>
import API from '@/api'

export default {
  data() {
    return {
      tableData: [],
      numberArr: [],
      // 外层弹窗
      loading: false,
      type: '',
      titleInside: '',
      dialogVisibleInside: false,
      // 现在已经选择的不通过理由
      arrNow: [],
      params: {
        pageNumber: 1,
        pageSize: 20,
      },
      // 内层弹窗
      id: '',
      flag: false,  
      form: {
        number: 0,
        content: '',
      },
      rules: {
        
      }
    }
  },
  props: ["isShow","reasonTotal","reasonTableData","reasonLoading","showType","isFocus"],
  methods: {
    // 内层弹窗关闭
    handleCloseInside() {
      this.dialogVisibleInside = false
      this.flag = false
      this.form = {
        content: '',
      }
    },
     // 内层表单提交验证
    submitDate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if(this.titleInside === "新增原因") {
            this.addReason();
          } else {
            this.editReason();
          }
        } else {
          return false;
        }
      });
    },
    // 新增原因
    addReason() {
      let num = 0;
      if(this.reasonTableData.length) {
          num = this.reasonTableData[this.reasonTableData.length-1].number
      } 
      let form = {
        number: ++num,
        content: this.form.content,
      }
      API.addFailList(form).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功！',
            type: 'success'
          });
          this.$emit("handReasonList")
        } else {
          this.$message.error('新增失败！');
        }
        this.flag = false
        this.handleCloseInside()
      }).catch(() => {
        this.$emit("handReasonList")
        this.flag = false
      })
    },
    // 编辑原因
    editReason() {
      API.editFailList(this.form).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功！',
            type: 'success'
          });
          this.$emit("handReasonList")
        } else {
          this.$message.error('编辑失败！')
        }
        this.handleCloseInside()
        this.flag = false
      }).catch(() => {
        this.handleCloseInside()
        this.flag = false
      })
    },
    removeAction(number) {
      this.$confirm('您确定要删除当前原因吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        API.delFailList({ numbers: [number] }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.$emit("handReasonList")
          } else {
            this.$message.error('删除失败！');
          }
        })
      })
    },
    // 新增编辑理由弹窗(内层弹窗)
    reasonAction(type,data) {
      this.dialogVisibleInside = true
      if(type === "add") {
        this.titleInside = "新增原因"
      } else {
        this.titleInside = "编辑原因"
        this.id = data.id
        this.form.number = data.number
        this.form.content = data.content
      }
    },
    // 判断某行是否点击过
    rowClick(row) {
      if(row.isClick) {
        row.isClick = false;
        this.$refs.multipleTable.toggleRowSelection(row, false)
      } else {
        row.isClick = true;
        this.$refs.multipleTable.toggleRowSelection(row, true)
      }
    },
    // 进行数据勾选时触发事件
    handleSelectionChange(row) {
      let arr = [];
      for(let i = 0 ; i<row.length; i++) {
        arr.push(row[i].content) 
      }
      let str = arr.join("；")
      this.$emit('handTextArea',str)
    },
    clear() {
      this.arrNow = [];
      this.numberArr = [];
    },
    getRowKeys(row) {
      return row.number;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size
      this.queryFailList()
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number
      this.queryFailList()
    },
  }
}
</script>